import ko from "knockout";

import CopyButton, { CopyButtonParams } from "./CopyButton";
import template from "./copy-button.html";
import "./copy-button.less";

ko.components.register("copy-button", {
    viewModel: {
        createViewModel: function (
            params: CopyButtonParams,
            componentInfo: any
        ) {
            return new CopyButton(params, componentInfo.element);
        },
    },
    template: template,
});
